import React, { FC, useRef } from "react";

import { Text, Tooltip } from "@epignosis_llc/gnosis";

import { useIsOverflow } from "@hooks";

type UserInfoProps = {
  name: string;
};

const UserInfo: FC<UserInfoProps> = ({ name }) => {
  const nameRef = useRef<HTMLSpanElement | null>(null);
  const isOverflowing = useIsOverflow(nameRef);

  return (
    <div className="info" data-testid="user-info-container">
      <Tooltip content={name} disabled={!isOverflowing}>
        <Text as="div" fontSize="sm" weight="700">
          <span ref={nameRef}>{name}</span>
        </Text>
      </Tooltip>
    </div>
  );
};

export default UserInfo;
